import React, {useEffect, useState} from 'react';
import {MyMatchesPlaceholder} from 'app/components/matchCalendar/MyMatchesPlaceholder';
import {Typography} from '@fupa/fupa-uikit';
import {Refresh} from '@mui/icons-material';

export const FollowsSyncPlaceholder = ({loadData}) => {
  const [counter, setCounter] = useState(10);

  useEffect(() => {
    let timer;
    if (counter > 0) {
      timer = setTimeout(() => setCounter(counter => counter - 1), 1000);
    } else {
      loadData(false, true);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [counter]);

  const reloadAction = {
    label: 'Sofort neu laden',
    onClick: () => loadData(false, true),
    actionIcon: <Refresh color='icon-invert' />,
  };

  return (
    <MyMatchesPlaceholder
      message={
        <>
          <Typography variant='body1'>
            Es scheint, als hättest du dich länger nicht eingeloggt.
            <br />
            Die Spiele deiner Favoriten werden gerade übertragen. Das kann einige wenige Sekunden in Anspruch nehmen.
            Wir bitten um etwas Geduld.
          </Typography>
          <br />
          <br />
          <Typography variant='body-strong'>Die Daten werden in {counter} Sekunden automatisch neu geladen.</Typography>
        </>
      }
      action={reloadAction}
    />
  );
};
